import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import { CurrencyService } from '../../../../services/currency.service';
import { PagerService } from '../../../../services/extra/pager.service';
import { CotizadorService } from '../../../../services/general/cotizador.service';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-busqueda',
  templateUrl: './busqueda.component.html',
  styleUrls: ['./busqueda.component.css']
})
export class BusquedaComponent implements OnInit {

@Input('resCotizacion') resCotizacion;
@Input('pager') pager;
@Input('pagedItems') pagedItems;
@Input('modelCotizacion') modelCotizacion;
@Input('model') model;
public polizas;
// Usamos el decorador Output
@Output() agregarPoliza = new EventEmitter();

public conversionMoneda;

    constructor(public _currencyService:CurrencyService,private pagerService: PagerService,private cs:CotizadorService) { }

    ngOnInit() {}

    setPage(page: number) {
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        // get pager object from service
        this.pager = this.pagerService.getPager(this.resCotizacion.polizas.length, page,4);

        // get current page of items
        this.pagedItems = this.resCotizacion.polizas.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    clausuladoPoliza(poliza){
        var ancho=800;
        var alto=500;
        var posicion_x;
        var posicion_y;
        posicion_x=(screen.width/2)-(ancho/2);
        posicion_y=(screen.height/2)-(alto/2);
        window.open(poliza.clausulado, "", "width="+ancho+",height="+alto+",menubar=0,toolbar=0,directories=0,scrollbars=no,resizable=no,left="+posicion_x+",top="+posicion_y+"");
    }

    detalleCoberturasPoliza(poliza){
        var ancho=800;
        console.log(poliza)
        var alto=500;
        var posicion_x;
        var posicion_y;
        posicion_x=(screen.width/2)-(ancho/2);
        posicion_y=(screen.height/2)-(alto/2);
        window.open(`https://embeddedapi.segurosmedicosinternacionales.com.co/pdfClausulado?id=${poliza.categoriaId}`, "", "width="+ancho+",height="+alto+",menubar=0,toolbar=0,directories=0,scrollbars=no,resizable=no,left="+posicion_x+",top="+posicion_y+"");
    }

    //Evento que recibe el click y dispara el event emitter hacia la ventana principal
    agregarCotizacion(event,p){
            // Usamos el método emit
            this.agregarPoliza.emit({poliza: p});
    }

    consultarPolizas(){
        this.polizas=[];
        //ConsultarPolizas
        $('#modalBusqueda').modal('hide');
        $('#divCargador').show();
        this.cs.getResCotizacion(JSON.stringify(this.modelCotizacion)).then(resc => {
                this.resCotizacion= resc;
                this.polizas=this.resCotizacion.polizas;
                //validamos las polizas que ya estan en la cotizacion
                for(var i = 0; i <= this.resCotizacion.polizas.length - 1; i++) {
                    this.resCotizacion.polizas[i].seleccionar=this.existePolizaSeleccionada(this.resCotizacion.polizas[i].id);
                }
                this.setPage(1);
            $('#divCargador').hide();
            $('#modalBusqueda').modal('show');
        });
    }

    existePolizaSeleccionada(Id){
        var guarda=false;
        this.model.polizas.forEach(function(obj) {
            if(Id==obj.id){ guarda=true;}
        });
        return guarda;
    }

    confirmarPoliza(){
        $('#modalBusqueda').modal('hide');
    }

    conversionMonedas(posicion:any, indice:String) {
        console.log(this.resCotizacion);
        if(this.resCotizacion.polizas[posicion - 1]) {
          let coleccion = JSON.stringify(this.resCotizacion.polizas[posicion - 1].conversionMoneda);
          this.conversionMoneda = JSON.parse(coleccion);
          let item = this.conversionMoneda.filter(x => x.id == indice)[0];
          return item.valor;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/intermediarios/cotizacion/busqueda/busqueda.component.ts